import { render, staticRenderFns } from "./SentiaStandardPricing.vue?vue&type=template&id=56ad5897&"
import script from "./SentiaStandardPricing.js?vue&type=script&lang=js&"
export * from "./SentiaStandardPricing.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports